<template>
  <div class="navbar">
    <hamburger :toggle-click="toggleSideBar" :is-active="sidebar.opened" class="hamburger-container"/>
    <breadcrumb/>

    <el-dropdown class="avatar-container" trigger="click">
      <div>
        {{ username }}
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu slot="dropdown" class="user-dropdown">
<!--        <router-link to="/app">-->
<!--          <el-dropdown-item>-->
<!--            回到主页-->
<!--          </el-dropdown-item>-->
<!--        </router-link>-->

        <el-dropdown-item>
          <span style="display:block;" @click="getProfile">我的信息</span>
        </el-dropdown-item>

        <el-dropdown-item divided>
          <span style="display:block;" @click="logout">登出用户</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dialog :visible.sync="dialogProfileVisible" :closeOnClickModal="false" title="用户信息">
      <dl style="line-height: 25px">
        <dt>邮箱地址:</dt>
        <dd>{{ userInfo.email }}</dd>
        <dt>用户别名:</dt>
        <dd>{{ userInfo.username }}</dd>
        <dt>登录时间:</dt>
        <dd>{{ userInfo.last_login }}</dd>
        <dt>用户令牌:</dt>
        <dd>{{ userInfo.token }}</dd>
      </dl>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogProfileVisible=false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import {formattime} from '@/utils/utils'
  import Breadcrumb from '@/components/Breadcrumb'
  import Hamburger from '@/components/Hamburger'

  export default {
    data() {
      return {
        dialogProfileVisible: false,
        userInfo: {
          email: '',
          username: '',
          last_login: '',
          token: '',
        }
      }
    },
    components: {
      Breadcrumb,
      Hamburger,
    },
    computed: {
      ...mapGetters([
        'sidebar',
        'avatar',
        'username'
      ])
    },
    created() {
      this.AccountId = this.$store.state.app.account_id
    },
    methods: {
      toggleSideBar() {
        this.$store.dispatch('ToggleSideBar')
      },
      logout() {
        this.$store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      },
      getProfile() {
        this.dialogProfileVisible = true
        this.$store.dispatch('GetInfo').then((data) => {
          data.data.last_login = formattime(data.data.last_login)
          this.userInfo = data.data
        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .navbar {
    height: 50px;
    line-height: 50px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
    .hamburger-container {
      line-height: 58px;
      height: 50px;
      float: left;
      padding: 0 10px;
    }
    .screenfull {
      position: absolute;
      right: 90px;
      top: 16px;
      color: red;
    }
    .search-input {
      position: absolute;
      right: 180px;
    }
    .avatar-container {
      height: 50px;
      display: inline-block;
      position: absolute;
      right: 35px;
      .avatar-wrapper {
        cursor: pointer;
        margin-top: 5px;
        position: relative;
        line-height: initial;
        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }

  dl {
    margin: 0;
  }

  dt, dd {
    display: inline;
    margin: 0;
    padding: 0;
  }

  dt {
    font-weight: bold;
  }

  dt::after {
    content: " ";
  }

  dt:not(:first-child):before {
    content: "\0A";
    white-space: pre;
  }
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue